export const CONST_ID = {
  CONCEPT: '7e6f278c-b950-437b-9a63-018DC1F0DEE9',
};
